export var MarketplaceFilterKey;
(function (MarketplaceFilterKey) {
    MarketplaceFilterKey["Product"] = "product";
    MarketplaceFilterKey["Publisher"] = "publisher";
    MarketplaceFilterKey["Category"] = "category";
})(MarketplaceFilterKey || (MarketplaceFilterKey = {}));
